export default __webpack_public_path__ + "static/media/m2money_logo.2d93a318.svg";